import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';

const STEPS = [
  {
    id: 1,
    title: 'Configura metales y categorias',
    description: 'Define los metales que compras y sus categorias de chatarra en Configuracion.',
    path: '/settings',
    linkLabel: 'Ir a Configuracion',
    icon: 'Settings',
    done: true,
  },
  {
    id: 2,
    title: 'Establece benchmarks de mercado',
    description: 'Carga precios LME, indices regionales y tipo de cambio EUR/USD en Datos de Mercado.',
    path: '/market-data',
    linkLabel: 'Ir a Mercado',
    icon: 'TrendingUp',
    done: true,
  },
  {
    id: 3,
    title: 'Crea tu primer lote en la Calculadora',
    description: 'Introduce los parametros del lote y obtén el precio maximo de compra recomendado.',
    path: '/batch-calculator',
    linkLabel: 'Ir a Calculadora',
    icon: 'Calculator',
    done: false,
  },
  {
    id: 4,
    title: 'Monitoriza el Inventario',
    description: 'Revisa la exposicion acumulada, antiguedad de lotes y alertas de riesgo.',
    path: '/inventory',
    linkLabel: 'Ir a Inventario',
    icon: 'Package',
    done: false,
  },
  {
    id: 5,
    title: 'Analiza resultados en Ventas',
    description: 'Calibra rendimientos y descuentos comparando precios esperados con los reales.',
    path: '/sales-analysis',
    linkLabel: 'Ir a Analisis',
    icon: 'BarChart2',
    done: false,
  },
];

export default function GettingStartedTab() {
  return (
    <div className="space-y-8">
      <div
        className="rounded-xl p-6 flex items-start gap-5"
        style={{
          background: 'linear-gradient(135deg, var(--color-accent) 0%, color-mix(in srgb, var(--color-accent) 70%, #000) 100%)',
          boxShadow: 'var(--shadow-lg)',
        }}
      >
        <div
          className="flex-shrink-0 flex items-center justify-center rounded-lg"
          style={{ width: 48, height: 48, background: 'rgba(255,255,255,0.15)' }}
        >
          <Icon name="Zap" size={26} color="#fff" strokeWidth={2.5} />
        </div>
        <div>
          <h2 className="font-bold text-white mb-1" style={{ fontSize: '1.25rem', fontFamily: 'var(--font-heading)' }}>
            Bienvenido a MetalRecovery
          </h2>
          <p className="text-white/80" style={{ fontSize: '0.9375rem', fontFamily: '"IBM Plex Sans", sans-serif', lineHeight: 1.6 }}>
            Motor de precios para recicladores de chatarra metalica. Calcula precios maximos de compra,
            gestiona exposicion de inventario y calibra rendimientos con datos de mercado en tiempo real.
          </p>
        </div>
      </div>
      <div>
        <h3
          className="font-semibold text-foreground mb-4"
          style={{ fontSize: '1rem', fontFamily: 'var(--font-heading)', letterSpacing: '-0.01em' }}
        >
          Checklist de configuracion inicial
        </h3>
        <div className="space-y-3">
          {STEPS?.map((step, idx) => (
            <div
              key={step?.id}
              className="flex items-start gap-4 rounded-lg p-4 border transition-all"
              style={{
                background: step?.done ? 'color-mix(in srgb, var(--color-success) 8%, var(--color-card))' : 'var(--color-card)',
                borderColor: step?.done ? 'color-mix(in srgb, var(--color-success) 30%, transparent)' : 'var(--color-border)',
              }}
            >
              <div
                className="flex-shrink-0 flex items-center justify-center rounded-full"
                style={{
                  width: 36,
                  height: 36,
                  background: step?.done ? 'var(--color-success)' : 'var(--color-muted)',
                }}
              >
                {step?.done ? (
                  <Icon name="Check" size={18} color="#fff" strokeWidth={2.5} />
                ) : (
                  <span className="font-bold" style={{ color: 'var(--color-muted-foreground)', fontSize: '0.875rem' }}>
                    {idx + 1}
                  </span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <Icon name={step?.icon} size={15} color="var(--color-accent)" strokeWidth={2} />
                  <span className="font-semibold text-foreground" style={{ fontSize: '0.9375rem', fontFamily: '"IBM Plex Sans", sans-serif' }}>
                    {step?.title}
                  </span>
                  {step?.done && (
                    <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{ background: 'var(--color-success)', color: '#fff' }}>
                      Completado
                    </span>
                  )}
                </div>
                <p className="mt-1 text-muted-foreground" style={{ fontSize: '0.875rem', fontFamily: '"IBM Plex Sans", sans-serif', lineHeight: 1.5 }}>
                  {step?.description}
                </p>
              </div>

              <Link
                to={step?.path}
                className="flex-shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-standard hover:opacity-80"
                style={{
                  background: 'var(--color-accent)',
                  color: '#fff',
                  fontFamily: '"IBM Plex Sans", sans-serif',
                  fontSize: '0.8125rem',
                  whiteSpace: 'nowrap',
                }}
              >
                {step?.linkLabel}
                <Icon name="ArrowRight" size={13} color="#fff" strokeWidth={2.5} />
              </Link>
            </div>
          ))}
        </div>
      </div>
      <div>
        <h3
          className="font-semibold text-foreground mb-4"
          style={{ fontSize: '1rem', fontFamily: 'var(--font-heading)', letterSpacing: '-0.01em' }}
        >
          Video de inicio rapido
        </h3>
        <div
          className="rounded-xl flex flex-col items-center justify-center gap-4 border"
          style={{
            height: 220,
            background: 'var(--color-muted)',
            borderColor: 'var(--color-border)',
            borderStyle: 'dashed',
          }}
        >
          <div
            className="flex items-center justify-center rounded-full"
            style={{ width: 64, height: 64, background: 'var(--color-accent)', opacity: 0.85 }}
          >
            <Icon name="Play" size={28} color="#fff" strokeWidth={2} />
          </div>
          <div className="text-center">
            <p className="font-medium text-foreground" style={{ fontSize: '0.9375rem', fontFamily: '"IBM Plex Sans", sans-serif' }}>
              Tour de MetalRecovery - 4 min
            </p>
            <p className="text-muted-foreground mt-1" style={{ fontSize: '0.8125rem', fontFamily: '"IBM Plex Sans", sans-serif' }}>
              Proximamente disponible
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
